// frontend/src/pages/FAQTabs.js
import React, { useState } from 'react';
import { Container, Row, Col, Accordion, Tab, Tabs } from 'react-bootstrap';
import './FAQTabs.css';

/**
 * Tamamen modüler ve özelleştirilebilir FAQTabs bileşeni
 * @param {Object} props - Bileşen özellikleri
 * @param {boolean} props.showTitle - Başlığı göster/gizle
 * @param {string} props.title - Başlık metni
 * @param {boolean} props.showContainer - Container bileşenini kullan/kullanma
 * @param {string} props.defaultActiveTab - Varsayılan aktif sekme
 * @param {Object} props.customTabs - Özel sekmeler ve içerikleri
 * @param {boolean} props.centerTabs - Sekmeleri ortala/ortalama
 * @param {string} props.id - Bileşen için benzersiz ID
 * @param {string} props.className - Ek CSS sınıfları
 */
const FAQTabs = ({
    showTitle = true,
    title = "Sorularla Otoprime'i Tanı",
    showContainer = true,
    defaultActiveTab = 'general',
    customTabs = null,
    centerTabs = true,
    id = "faq-section",
    className = ""
}) => {
    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    // Varsayılan sekme içerikleri
    const defaultTabContents = {
        general: [
            {
                id: 0,
                question: "Otoprime nedir?",
                answer: "Otoprime, araç alım-satımında dijital çözümler sunan bir platformdur."
            },
            {
                id: 1,
                question: "Araçlarınız ekspertizli mi?",
                answer: "Tüm araçlarımız ekspertiz raporlu ve kilometresi garantilidir."
            },
            {
                id: 2,
                question: "Satın alma işlemi nasıl gerçekleşir?",
                answer: "Web sitemiz üzerinden başvurabilir, yerinde ya da online işlemleri tamamlayabilirsiniz."
            }
        ],
        services: [
            {
                id: 0,
                question: "Krediyle Ödeme",
                answer: "Anlaşmalı bankalarla düşük faizli kredi imkanı sunarız."
            },
            {
                id: 1,
                question: "Senetle Ödeme",
                answer: "Kredi notu düşük müşterilerimiz için senetle ödeme seçeneği sunarız."
            },
            {
                id: 2,
                question: "Takas İmkanı",
                answer: "Eski aracınızı vererek yeni araç alımında indirim kazanabilirsiniz."
            }
        ],
        payment: [
            {
                id: 0,
                question: "Ödemeleri nasıl yapabilirim?",
                answer: "EFT/havale, kredi kartı veya senet ile ödeme yapılabilir."
            },
            {
                id: 1,
                question: "Peşin alımda indirim var mı?",
                answer: "Evet, peşin ödemelerde indirim uygulanır."
            },
            {
                id: 2,
                question: "Kredi süreci ne kadar sürer?",
                answer: "Evraklar tamamlandıktan sonra ortalama 1 iş günü içinde tamamlanır."
            }
        ]
    };

    // Özel veya varsayılan sekme içeriklerini kullan
    const tabContents = customTabs || defaultTabContents;

    // Sekme başlıkları
    const tabTitles = {
        general: "Genel",
        services: "Hizmetler",
        payment: "Ödeme Seçenekleri"
    };

    // İçerik bileşeni
    const TabContent = ({ tabKey }) => (
        <Row className="justify-content-center">
            <Col lg={10}>
                <Accordion defaultActiveKey="0">
                    {tabContents[tabKey].map((item) => (
                        <Accordion.Item key={item.id} eventKey={item.id.toString()}>
                            <Accordion.Header>{item.question}</Accordion.Header>
                            <Accordion.Body>{item.answer}</Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Col>
        </Row>
    );

    // İçerik bölümü
    const Content = () => (
        <>
            {showTitle && <h2 className="section-title text-center mb-5">{title}</h2>}

            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id={`${id}-tabs`}
                className={`mb-4 ${centerTabs ? 'justify-content-center' : ''}`}
            >
                {Object.keys(tabContents).map((tabKey) => (
                    <Tab key={tabKey} eventKey={tabKey} title={tabTitles[tabKey] || tabKey}>
                        <TabContent tabKey={tabKey} />
                    </Tab>
                ))}
            </Tabs>
        </>
    );

    // Container ile veya Container'sız render
    return (
        <section className={`faq-tabs-section py-5 ${className}`} id={id}>
            {showContainer ? (
                <Container>
                    <Content />
                </Container>
            ) : (
                <Content />
            )}
        </section>
    );
};

export default FAQTabs;